import JsonNode from './types/json';

export const jsonNodes = {
  json: JsonNode,
};
